import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {TrvNgMapService} from "@trafikverket/trv-ng-map";
import {
    TrvGlobalMessagesService,
    TrvModalService,
    TrvPopoverPosition,
    TrvPopoverRef,
    TrvPopoverDirective, TrvSelectComponent
} from "@trv-hub/trv-ng-common";
import {LocalStorageService, SavedView} from "src/app/service/local-storage.service";
import {SWEDEN_VIEW} from "src/app/shared/constants";
import {SaveViewComponent} from '@components/map-menu/saved-view-section/save-view/save-view.component'
import {NgClass} from "@angular/common";
import {SavedViewItemComponent} from "./saved-view-item/saved-view-item.component";
import {ReactiveFormsModule} from "@angular/forms";
import {NvdbNavigationService, sortByOptions, sortByOptionsEn, SortingStrategies} from "@app/service/nvdb-navigation.service";
import { Language, LanguageService } from "@app/service/language.service";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-saved-view-section',
    templateUrl: './saved-view-section.component.html',
    styleUrls: ['../../map-menu/map-menu.component.scss', './saved-view-section.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        TrvPopoverDirective,
        SavedViewItemComponent,
        TrvSelectComponent,
        ReactiveFormsModule,
        NgClass
    ]
})
export class SavedViewSectionComponent {
    public popoverPosition: TrvPopoverPosition[] = ["right", "bottom-end", "bottom", "bottom-start", 'top-start', 'top-end'];
    public popoverComponent = SaveViewComponent;
    private sub?: Subscription;
    protected sortByOptionsSource = sortByOptions;

    protected _sortByOptions = sortByOptions;
    protected _sortByOptionsEn = sortByOptionsEn;



    sortedSavedViews: SavedView[] = []

    constructor(
        public localStorageService: LocalStorageService,
        public nvdbNavigationService: NvdbNavigationService,
        public lang: LanguageService,
        private cd: ChangeDetectorRef
    ) {
        this.sortSavedViews()

        this.nvdbNavigationService.savedViewsSortBy.valueChanges.subscribe(() => this.sortSavedViews())
        this.nvdbNavigationService.savedViewsSortByEn.valueChanges.subscribe(() => this.sortSavedViews())
        this.localStorageService.savedViewsChanged.subscribe(() => this.sortSavedViews())
    }

    ngOnInit(): void {
        this.lang.currentLanguage$.subscribe(() => {
            // Uppdatera source-listan
            this.sortByOptionsSource = this.lang.currentLanguage === Language.SV ? [...sortByOptions] : [...sortByOptionsEn];
          
            const current = this.nvdbNavigationService.savedViewsSortBy.value;
            if (!current) return;
          
            // Hitta objekt i nya listan
            const found = this.sortByOptionsSource.find(o => o.strategy === current.strategy);
            if (found) {
              // Skapa ny kopia med uppdaterad text
              const updatedObj = { ...found };
          
              // Sätt FormControl till nya kopian
              this.nvdbNavigationService.savedViewsSortBy.setValue(updatedObj, { emitEvent: false });
            }
          });

        }

    ngONDestroy() {
        this.sub?.unsubscribe();
    }

    displaySortByName = (itemOrStrategy: any): string => {

        return itemOrStrategy.name;
      };



    public sortSavedViews() {
        switch (this.nvdbNavigationService.savedViewsSortBy.value.strategy) {
            case SortingStrategies.ALPHA_A_TO_Z:
                this.sortedSavedViews = [...this.localStorageService.savedViews].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                break;
            case SortingStrategies.ALPHA_Z_TO_A:
                this.sortedSavedViews = [...this.localStorageService.savedViews].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1)
                break;
            case SortingStrategies.CREATED_NEW_FIRST:
                this.sortedSavedViews = [...this.localStorageService.savedViews].sort((a, b) => a.lastModifiedDate.diff(b.lastModifiedDate).toMillis() > 0 ? -1 : 1)
                break;
            case SortingStrategies.CREATED_OLD_FIRST:
                this.sortedSavedViews = [...this.localStorageService.savedViews].sort((a, b) => a.lastModifiedDate.diff(b.lastModifiedDate).toMillis() > 0 ? 1 : -1)
                break;
        }
    }

    public isDefaultView(savedView: SavedView): boolean {
        return this.localStorageService.defaultViewId === savedView?.id;
    }

    onShowComponent(ref: TrvPopoverRef<SaveViewComponent>): void {
    }

    protected readonly SWEDEN_VIEW = SWEDEN_VIEW;

  //  public displaySortByName(obj: { strategy: SortingStrategies, name: string }) {
  /*      let options = sortByOptions;
        if (this.lang.currentLanguage == Language.ENG) {
            options = sortByOptionsEn;
        }
        const found = options.find(o => o.strategy === obj.strategy);
        if (found) {
            return found.name;
        }*/
     //   return obj.name
   // };

    protected readonly sortByOptions = sortByOptions;
    protected readonly sortByOptionsEn = sortByOptionsEn;
    protected readonly Language = Language;



    
}


